import MuiTableCell, {
    TableCellProps as MuiTableCellProps,
    TableCellBaseProps as MuiTableCellBaseProps,
    SortDirection as MuiSortDirection,
    TableCellClassKey as MuiTableCellClassKey,
    Padding as MuiPadding
} from "@material-ui/core/TableCell";


export type Padding = MuiPadding;
export type SortDirection = MuiSortDirection;
export type TableCellClassKey = MuiTableCellClassKey;
export type TableCellBaseProps = MuiTableCellBaseProps;
export type TableCellProps = MuiTableCellProps;

export default MuiTableCell;

